import ReviewCard from './ReviewCard';

export default function EventReviewViewer({ eventReviews }) {
  return (
    <div className="flex-col items-center justify-between w-full mt-5">
      {eventReviews?.length > 0 && (
        <>
          {eventReviews.map((reviewItem) => (
            <div className="mt-6" key={reviewItem.Id}>
              <ReviewCard review={reviewItem} />
            </div>
          ))}
        </>
      )}
    </div>
  );
}
